var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSearchResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 367,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M349.168 27.423v273.313H26.799V27.423h322.369zm1.054-1.053H25.745v275.42h324.477V26.37z",
    fill: "#C4ECFE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M350.222 221.627H25.745v.986h324.477v-.986zM350.222 182.175H25.745v.985h324.477v-.985z",
    fill: "#C4ECFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M350.222 221.627H25.745v.986h324.477v-.986zM350.222 261.046H25.745v.985h324.477v-.985zM350.222 142.756H25.745v.986h324.477v-.986zM350.222 103.304H25.745v.985h324.477v-.985zM350.222 63.885H25.745v.986h324.477v-.986z",
    fill: "#C4ECFE"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.264 301.79l-.034-1.971c0 .645.035 1.291.035 1.971z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.531 232.909a1.886 1.886 0 01-1.871-1.869v-63.715c0-1.02.85-1.869 1.871-1.869 1.02 0 1.87.849 1.87 1.869v63.715c0 1.02-.85 1.869-1.87 1.869z",
    fill: "#CAE6C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M325.53 181.291c-.102 0-.204 0-.306-.034a1.853 1.853 0 01-1.53-2.141 9.826 9.826 0 0110.441-8.189c1.02.068 1.802.985 1.734 2.005-.068 1.019-.986 1.801-2.006 1.733a6.103 6.103 0 00-6.496 5.063c-.136.918-.952 1.563-1.837 1.563z",
    fill: "#CAE6C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M325.53 181.291c-.884 0-1.7-.645-1.836-1.563-.51-3.126-3.299-5.301-6.496-5.063-1.02.068-1.938-.68-2.006-1.733-.068-1.054.68-1.937 1.734-2.005 5.136-.374 9.625 3.126 10.441 8.189a1.853 1.853 0 01-1.531 2.141c-.102.034-.204.034-.306.034zM325.53 190.636c-.102 0-.204 0-.306-.034a1.853 1.853 0 01-1.53-2.141 9.826 9.826 0 0110.441-8.189c1.02.068 1.802.985 1.734 2.005-.068 1.019-.986 1.801-2.006 1.733a6.103 6.103 0 00-6.496 5.063c-.136.917-.952 1.563-1.837 1.563z",
    fill: "#CAE6C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.53 190.636c-.884 0-1.7-.646-1.836-1.563-.51-3.126-3.299-5.301-6.496-5.063-1.02.068-1.938-.68-2.006-1.733-.068-1.054.68-1.937 1.734-2.005 5.136-.374 9.625 3.126 10.441 8.189a1.853 1.853 0 01-1.531 2.141c-.102.034-.204.034-.306.034zM301.521 241.948a1.887 1.887 0 01-1.871-1.869v-49.205c0-1.019.851-1.869 1.871-1.869s1.87.85 1.87 1.869v49.205c0 1.02-.85 1.869-1.87 1.869z",
    fill: "#CAE6C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M301.521 204.84c-.102 0-.204 0-.306-.034a1.852 1.852 0 01-1.531-2.14 9.826 9.826 0 0110.441-8.19c1.02.068 1.802.985 1.734 2.005-.068 1.019-.986 1.801-2.006 1.733a6.103 6.103 0 00-6.496 5.063c-.136.918-.952 1.563-1.836 1.563z",
    fill: "#CAE6C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.521 204.84c-.885 0-1.701-.645-1.837-1.563-.51-3.126-3.299-5.301-6.495-5.063-1.021.068-1.939-.68-2.007-1.733-.068-1.019.68-1.937 1.734-2.005 5.102-.374 9.625 3.126 10.441 8.19a1.852 1.852 0 01-1.53 2.14c-.102.034-.204.034-.306.034zM301.521 214.219c-.102 0-.204 0-.306-.034a1.852 1.852 0 01-1.531-2.14 9.826 9.826 0 0110.441-8.19c1.02.068 1.802.985 1.734 2.005-.068 1.019-.986 1.801-2.006 1.733a6.103 6.103 0 00-6.496 5.063c-.136.918-.952 1.563-1.836 1.563z",
    fill: "#CAE6C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.521 214.219c-.885 0-1.701-.645-1.837-1.563-.51-3.126-3.299-5.301-6.495-5.063-1.021.068-1.939-.68-2.007-1.733-.068-1.054.68-1.937 1.734-2.005 5.136-.374 9.625 3.126 10.441 8.189a1.853 1.853 0 01-1.53 2.141c-.102.034-.204.034-.306.034zM45.81 278.58c-1.02 0-1.87-.849-1.87-1.869v-40.132c0-1.019.85-1.869 1.87-1.869s1.87.85 1.87 1.869v40.132c0 1.02-.85 1.869-1.87 1.869z",
    fill: "#CAE6C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.81 250.545c-.102 0-.204 0-.306-.034a1.852 1.852 0 01-1.53-2.14 9.826 9.826 0 0110.44-8.19c1.02.068 1.802.985 1.734 2.005-.068 1.019-.986 1.801-2.006 1.733a6.103 6.103 0 00-6.496 5.063c-.136.918-.952 1.563-1.836 1.563z",
    fill: "#CAE6C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.81 250.545c-.885 0-1.7-.645-1.837-1.563-.51-3.126-3.299-5.301-6.495-5.063-1.02.068-1.939-.68-2.007-1.733-.068-1.019.68-1.937 1.735-2.005 5.1-.374 9.624 3.126 10.44 8.19a1.852 1.852 0 01-1.53 2.14c-.102.034-.204.034-.306.034z",
    fill: "#CAE6C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M350.323 247.861v30.073c0 12.744-10.338 23.108-23.126 23.108H194.359s4.966-40.404 65.229-40.404c33.839 0 26.323-17.704 48.803-34.185 17.412-12.777 41.932-.136 41.932 21.408z",
    fill: "url(#paint1_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.241 300.226h103.387c0-21.442-11.223-25.792-23.5-26.233-10.68-.408-13.332-20.559-31.22-17.773-10.815 1.699-11.495 10.908-20.984 12.947-8.366 1.801-27.683 9.311-27.683 31.059z",
    fill: "url(#paint2_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.676 132.256c6.564-10.874 15.95-17.908 27.853-28.579 11.903-10.67 12.855-35.238 15.1-46.826 1.326-6.796 13.059-20.117 4.285-26.404 0 0-10.849-2.072-21.119 10.093-3.979 2.005-7.754 3.772-13.264 6.558-16.392 8.19-11.529 22.87-18.704 30.55-7.142 7.68-63.97 10.126-76.894 27.457-27.921 37.447 53.972 74.895 82.743 27.151z",
    fill: "url(#paint3_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M283.224 300.057H66.249v1.393h216.975v-1.393z",
    fill: "#2B2B2B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.047 140.378l-28.635-3.67c-2.007-.272-3.809-1.122-5.204-2.413l-.748-.714-38.26-34.933c-5.339-4.86-5.713-13.15-.85-18.486 4.863-5.335 13.162-5.709 18.501-.85l38.26 34.934-5.952-3.093 27.615 8.972-4.727 20.253z",
    fill: "#565656"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M243.774 120.125l9.863 3.194c4.965 1.631 7.686 6.966 6.087 11.927-1.428 4.384-5.781 7.035-10.202 6.457l-10.441-1.325 4.693-20.253z",
    fill: "#FDC068"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M192.999 119.751c-.782-14.374-10.611-13.185-7.312-23.04 3.299-9.854-1.802-23.141-12.855-22.563-8.502.441-9.115.136-12.719.34-11.359.611-18.569 12.539-14.726 23.243 0 0 .986 2.412 1.088 5.675.102 3.262-7.652 8.461-7.108 18.35l53.632-2.005z",
    fill: "#565656"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.045 297.1l-32.547-26.03c-1.7-1.359-2.074-3.772-.85-5.437l2.993-4.01 20.405 16.651 12.719 16.142c1.463 1.869-.85 4.179-2.72 2.684z",
    fill: "#2B2B2B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.368 121.722c.408 7.578 8.944 18.52 22.174 17.908l10.645-.816c12.073-.543 21.187-11.791 20.745-19.947l-53.564 2.855z",
    fill: "url(#paint4_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82.607 261.623l19.487 16.957c1.089-1.291 2.075-2.65 3.129-3.976 1.02-1.325 2.007-2.684 3.027-4.009l1.496-2.005 1.463-2.039 2.924-4.078a174.79 174.79 0 002.891-4.112 289.994 289.994 0 002.823-4.112c.918-1.393 1.87-2.752 2.789-4.145l2.754-4.18c7.278-11.146 14.182-22.496 20.848-33.981l1.258-2.141c.204-.374.442-.714.612-1.088l.544-1.121a180.013 180.013 0 002.177-4.452l2.176-4.485.851-1.801 1.258-2.685c1.428-2.99 2.755-6.015 4.149-9.039.68-1.495 1.326-3.024 2.007-4.553.68-1.53 1.326-3.025 1.972-4.554.034-.034.034-.102.068-.136 2.585-6.049 4.999-12.199 7.278-18.384.612-1.665 1.224-3.33 1.802-5.029.51-1.461 1.021-2.922 1.497-4.418l1.53-4.757.714-2.413.34-1.189.34-1.223-7.107-3.195-10.883-4.791-19.453-8.767-12.209 37.651-7.38 18.214-1.496 3.704-2.211 5.403-1.837 4.554-.476 1.121c-.136.374-.34.748-.51 1.122l-1.02 2.242-29.622 65.89z",
    fill: "url(#paint5_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.679 126.887l8.774 41.389 2.279 10.704 2.108 9.991c.272 1.257.544 2.515.782 3.772 1.225 5.641 2.483 11.282 3.265 16.957l13.468 83.22 25.302-.917c.102-1.767.068-4.248.136-6.015.068-1.767.102-3.534.136-5.301l.068-2.651c.034-.883 0-1.767 0-2.65v-7.952l-.034-2.65c-.034-1.767-.034-3.534-.068-5.301l-.136-5.302-.17-5.301c-.476-14.136-1.36-28.238-2.483-42.375-.306-3.534-.51-7.068-1.088-10.568l-.782-5.267-.374-2.65-.408-2.651-.851-5.267-.918-5.267-.476-2.617-.476-2.616-.986-5.268c-1.361-7-2.891-13.966-4.557-20.932-1.701-6.966-5.17-16.413-7.448-23.277l-24.147 2.48-8.638 3.364-2.278.918z",
    fill: "url(#paint6_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M232.653 300.26l-40.641-.17c-2.142 0-4.013-1.699-4.285-3.839l-.612-5.132 25.711.374 19.929 4.86c2.312.577 2.244 3.907-.102 3.907z",
    fill: "#2B2B2B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.947 65.958h-9.965c-5.169 0-9.352-4.18-9.352-9.31v-15.02c0-8.258 6.666-14.919 14.93-14.919s14.93 6.66 14.93 14.918V55.39c.034 5.845-4.694 10.568-10.543 10.568z",
    fill: "#FDC068"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.007 47.642a1.7 1.7 0 10.001-3.399 1.7 1.7 0 00-.001 3.399zM173.614 82.1l7.89-4.452s-2.176-4.01-11.019-3.534l3.129 7.985z",
    fill: "#2B2B2B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.125 82.983l-12.787-4.69 1.326-28.374h15.882l1.497 28.714c.17 3.127-2.959 5.437-5.918 4.35z",
    fill: "#FDC068"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M180.858 51.074a.472.472 0 01-.408-.238.456.456 0 01.17-.645l1.36-.782c.136-.102.205-.272.239-.442a.559.559 0 00-.171-.51l-2.108-2.514a.485.485 0 01.068-.68.485.485 0 01.68.068l2.109 2.515a1.669 1.669 0 01-.238 2.345l-.068.034-1.395.815c-.068.034-.17.034-.238.034zM179.158 56.715c-.238 0-.476-.204-.476-.442 0-.272.204-.475.442-.51l3.231-.17c.272 0 .476.205.51.442.034.238-.204.476-.442.51l-3.265.17zM174.396 65.958l-6.496.034 6.836 6.389-.34-6.423zM175.315 47.71a1.7 1.7 0 10.001-3.399 1.7 1.7 0 00-.001 3.399z",
    fill: "#2B2B2B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M105.189 131.203c12.073-10.331 7.312-15.292 24.078-23.142s19.827-38.399 28.363-51.414c4.999-7.612 23.126-18.69 18.739-30.005 0 0-8.672-7.103-24.792 3.194-4.728.747-9.149 1.291-15.678 2.276-19.453 2.889-23.33 22.666-34.111 28.885-10.815 6.218-33.26-7-54.686 8.427-46.354 33.37 5.203 107.11 58.087 61.779z",
    fill: "url(#paint7_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.474 63.75h-.034l-11.835-1.156a.495.495 0 11.102-.985l11.835 1.155a.495.495 0 01.442.543.515.515 0 01-.51.442zM153.685 65.109h-.068a.495.495 0 01-.442-.544l.748-7.17a.495.495 0 11.986.102l-.748 7.17c0 .238-.204.442-.476.442z",
    fill: "#2B2B2B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.676 53.69l4.489-6.592c2.959-4.315 8.842-5.437 13.161-2.514 3.809 2.582 5.136 7.476 3.367 11.553l-2.551 5.913-18.466-8.36z",
    fill: "#FDC068"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M143.177 62.084l-12.516 29.19-9.726-19.267 31.254 4.621a13.092 13.092 0 0111.223 14.714 13.098 13.098 0 01-14.726 11.214l-31.254-4.621-1.19-.17c-6.734-.918-11.461-7.102-10.543-13.83a12.687 12.687 0 012.007-5.268l17.004-24.976 18.467 8.393z",
    fill: "#565656"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M177.695 27.321s2.075 8.291 9.829 14.306c0 0 .578-13.83-9.829-14.306z",
    fill: "url(#paint8_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M256.187 76.356h-6.801v89.542h6.801V76.356z",
    fill: "#F9D5FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M256.187 76.356h-6.801v26.574h6.801V76.356z",
    fill: "#2B2B2B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M266.186 29.496h-26.799l-18.943 18.928V75.2l18.943 18.928h26.799L285.163 75.2V48.424l-18.977-18.928z",
    fill: "#F48B94"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M266.186 96.643h-26.799c-.68 0-1.326-.272-1.768-.747l-18.943-18.928a2.527 2.527 0 01-.748-1.767V48.424c0-.68.272-1.326.748-1.767l18.943-18.928a2.53 2.53 0 011.768-.748h26.799c.68 0 1.292.272 1.769.748l18.976 18.928c.476.475.749 1.121.749 1.767V75.2c0 .68-.273 1.325-.749 1.767l-18.976 18.928a2.474 2.474 0 01-1.769.747zm-25.745-5.029h24.725l17.514-17.466v-24.67L265.166 32.01h-24.725l-17.48 17.466v24.705l17.48 17.432z",
    fill: "#F9D5FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M262.955 55.016c0 .985-.272 2.005-.782 3.024-.51 1.02-1.394 2.311-2.619 3.874l-1.972 2.549c-.51.646-.918 1.19-1.224 1.597a9.169 9.169 0 00-.749 1.02c-.17.271-.306.51-.374.713a2.133 2.133 0 00-.102.646v1.223c0 .272-.102.476-.34.612a1.429 1.429 0 01-.714.204h-4.387a.726.726 0 01-.578-.272.819.819 0 01-.238-.612v-1.19c0-.543 0-1.087.034-1.563.034-.475.102-.95.238-1.393.136-.441.306-.883.578-1.325.238-.442.578-.952.986-1.53l2.109-2.752c.816-1.087 1.36-1.937 1.632-2.548a4.674 4.674 0 00.408-1.903v-.442c0-.51-.17-.883-.51-1.19-.34-.305-.884-.441-1.666-.441-1.157 0-2.211.034-3.197.136-.986.102-2.007.204-3.095.34h-.136c-.51 0-.748-.306-.748-.918v-3.908c0-.306.034-.577.17-.747.102-.17.306-.306.646-.408.952-.306 2.041-.51 3.299-.68a27.999 27.999 0 013.741-.238c1.53 0 2.891.136 4.081.374 1.19.238 2.176.646 3.027 1.224a5.807 5.807 0 011.904 2.242c.442.918.646 2.073.646 3.466v.816h-.068zm-7.448 24.67a.726.726 0 01-.272.578.82.82 0 01-.612.238h-5.203a.82.82 0 01-.612-.238c-.17-.17-.272-.374-.272-.578v-5.538a.85.85 0 01.272-.612.852.852 0 01.612-.272h5.203c.238 0 .442.102.612.272a.85.85 0 01.272.612v5.538z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M256.732 125.018s-7.686 2.243-8.162 4.214c-.714 3.058-2.687 11.553-.952 12.233 1.734.679 10.474-3.194 10.474-3.194l-1.36-13.253z",
    fill: "#FDC068"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M165.69 170.485c-.068 0-.136 0-.17-.034-.272-.102-.408-.408-.306-.646l8.162-21.884c.102-.272.408-.407.646-.305.272.101.408.407.306.645l-8.162 21.884a.511.511 0 01-.476.34zM152.359 103.168h-.068l-5.986-.816a.528.528 0 01-.442-.577.528.528 0 01.578-.442l5.986.815a.528.528 0 01.442.578.511.511 0 01-.51.442zM192.557 123.047c-.034 0-.102 0-.136-.034-.272-.068-.442-.374-.34-.612 1.734-6.15-1.769-11.349-6.564-18.554l-.442-.645c-.17-.238-.102-.544.136-.714.238-.17.544-.102.714.136l.442.646c4.966 7.408 8.57 12.777 6.7 19.369a.505.505 0 01-.51.408zM216.567 113.77a.541.541 0 01-.51-.408.505.505 0 01.374-.611l3.571-.782a.507.507 0 11.238.985l-3.571.782c-.034.034-.068.034-.102.034z",
    fill: "#2B2B2B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M70.772 165.694a1.394 1.394 0 100-2.788 1.394 1.394 0 000 2.788zM311.452 279.464a1.394 1.394 0 100-2.787 1.394 1.394 0 000 2.787zM312.812 52.331a1.394 1.394 0 10.001-2.788 1.394 1.394 0 00-.001 2.788zM213.03 91.92a1.394 1.394 0 100-2.787 1.394 1.394 0 000 2.787zM143.959 60.895a1.394 1.394 0 100-2.787 1.394 1.394 0 000 2.787zM251.868 235.933a1.292 1.292 0 10.002-2.584 1.292 1.292 0 00-.002 2.584zM70.772 249.968a1.292 1.292 0 10.001-2.583 1.292 1.292 0 00-.001 2.583z",
    fill: "#BFD9FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M270.913 200.83l-.986-3.262c14.589-4.383 23.024-17.33 31.22-29.869 8.468-12.981 16.46-25.249 30.438-25.792l.136 3.398c-12.21.476-19.385 11.485-27.718 24.229-8.094 12.437-17.276 26.573-33.09 31.296zM68.494 223.734c-6.972-2.141-12.447-12.301-17.787-22.122-4.353-8.087-9.318-17.228-13.365-17.228v-3.399c6.087 0 10.849 8.802 16.358 18.996 4.761 8.801 10.169 18.758 15.78 20.491l-.986 3.262z",
    fill: "#F9D5FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50.248,
    y1: 299.819,
    x2: 50.248,
    y2: 301.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 272.341,
    y1: 221.829,
    x2: 272.341,
    y2: 295.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 78.934,
    y1: 254.018,
    x2: 78.934,
    y2: 302.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 180.507,
    y1: 36.227,
    x2: 76.206,
    y2: 126.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.029,
    stopColor: "#2A7CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#418BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#AAB5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 166.158,
    y1: 298.789,
    x2: 166.158,
    y2: 119.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 129.709,
    y1: 298.948,
    x2: 129.709,
    y2: 118.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 184.845,
    y1: 298.839,
    x2: 184.845,
    y2: 117.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 202.993,
    y1: 31.93,
    x2: 80.609,
    y2: 98.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 152.05,
    y1: 50.205,
    x2: 197.577,
    y2: 26.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#7AAEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#B8C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4D4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/no-search-results.4f19425532d805119ede693b877b710a.svg";
export { ForwardRef as ReactComponent };